export default __webpack_public_path__ + "static/media/Barlow-Regular.e7eb634d.ttf";